(function () {
  'use strict';

  angular.module('ringbaPortal').controller('SidebarController', SidebarController);

  function SidebarController(
    $scope,
    $state,
    $translate,
    accountsService,
    authService,
    callLogsService,
    savedReportService,
    sidebarService,
    utilities,
    VuexStore,
    featureFlags,
    supportChatService,
    systemFlagsService,
    v3HandoffService
  ) {
    'ngInject';

    const vm = this;

    const render = utilities.safeApply.bind($scope);

    vm.scrollOption = {
      height: '100%'
    };

    vm.$onInit = onInit;
    vm.$onDestroy = onDestroy;
    vm.$state = $state;
    vm.hasAccess = accountsService.hasAccess;
    vm.sidebarService = sidebarService;
    vm.isAffiliate = accountsService.isAffiliate;
    vm.isBuyer = accountsService.isBuyer;
    vm.expandMenuMapping = sidebarService.expandMenuMapping;
    vm.isMenuActive = isMenuActive;
    vm.logOut = logOut;
    vm.supportChatService = supportChatService;
    vm.hasBulkTagsV3 = function () { return v3HandoffService.handsOff('bulkTags'); };
    vm.hasTcpaShieldV3 = function () { return v3HandoffService.handsOff('tcpaShield'); };
    vm.hasUserGroupsV3 = function () { return v3HandoffService.handsOff('userGroups'); };
    // Redirect-only pages: V2 has none of its own, so their links show only when V2 hands them off.
    vm.hasRecordingAccessV3 = function () { return v3HandoffService.handsOff('recordings'); };
    vm.hasInboundBidRequestsV3 = function () {
      // Admin, Report Access and Read Only: Reporting > Real Time Bidding also admits the manager roles.
      const roles = (accountsService.currentPermissions && accountsService.currentPermissions.roles) || [];
      // `rtb` is read here, not through a `feature-flag` attribute: that directive swaps out the node ng-if removes, so the link would outlive a level drop.
      return __BUILD_CONFIG__.routes.rtbSummary != null
        && v3HandoffService.handsOff('rtbSummary')
        && featureFlags.isOn('rtb')
        && ['admin', 'user', 'readonly'].some(function (role) { return roles.indexOf(role) !== -1; });
    };
    vm.hasOutboundPingInsightsV3 = function () {
      return v3HandoffService.handsOff('outboundPingInsights') && canReadRingTreeTargetInsights();
    };
    vm.hasOutboundBidRequestsV3 = function () {
      return v3HandoffService.handsOff('outboundBidRequests') && canReadRingTreeTargetInsights();
    };
    vm.hasRingTreeAdvancedSettingsV3 = function () {
      return v3HandoffService.handsOff('ringTreeAdvancedSettings')
        && systemFlagsService.values.portalRttV3
        && featureFlags.isOn('pingtree')
        && accountsService.isAdmin();
    };
    vm.hasNumberPoolSummaryV3 = function () {
      // Account roles only: a publisher can read pools but gets no pool reporting.
      const roles = (accountsService.currentPermissions && accountsService.currentPermissions.roles) || [];
      return __BUILD_CONFIG__.routes.numberPoolSummary != null
        && v3HandoffService.handsOff('numberPoolSummary')        && ['admin', 'user', 'readonly'].some(function (role) { return roles.indexOf(role) !== -1; });
    };

    function onInit() {
      vm.isAdmin = accountsService.isAdmin();
      vm.isReportReadOnlyUser = accountsService.isReportReadOnlyUser();
      vm.isReadOnlySuperUser = accountsService.isReadOnlySuperUser();

      utilities.ngVueEventBus.$on(utilities.ngVueEvents.EVENT_SAVED_INSIGHTS_UPDATED, _renderOnSavedInsightsUpdated);
      VuexStore.dispatch('reporting/getSavedReports');

      $translate('MENU_LEFT_INSIGHT_ACCOUNT_VISIBLE').then(function getTranslation(translated) {
        vm.accountHelperTooltip = translated;
      });
    }

    function onDestroy() {
      utilities.ngVueEventBus.$off(utilities.ngVueEvents.EVENT_SAVED_INSIGHTS_UPDATED, _renderOnSavedInsightsUpdated);
    }

    function logOut() {
      vm.supportChatService.logoutFromChat();

      callLogsService.removeJobsFromCache(accountsService.currentAccountId);
      authService.logOut();
      $state.go('login');
    }

    function isMenuActive(sectionName) {
      const mapping = vm.expandMenuMapping[sectionName];
      let result = false;

      if (!mapping) {
        return result;
      }

      mapping.forEach(function checkIsMenuActiveMapping(value) {
        result = result || vm.$state.includes(value);
      });

      return result;
    }

    function canReadRingTreeTargetInsights() {
      return featureFlags.isOn('pingtree')
        && accountsService.hasAccess('CallLog', 'READ')
        && accountsService.isAdmin();
    }

    function _renderOnSavedInsightsUpdated() {
      vm.savedInsights = VuexStore.getters['reporting/savedInsights'];
      vm.savedCallLogs =VuexStore.getters['reporting/savedCallLogs'];
      render();
    }
  }
})();
